import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import AdminLayout from '@app/layout/AdminLayout.tsx';
import AdminCompanyInheriters from '@components/pages/admin/AdminCompanyInheriters/AdminCompanyInheriters';
import { useParams } from 'react-router-dom';

interface ComponentProps {}

const InheritersPage: React.FC<ComponentProps> = () => {
  const { customerId } = useParams();

  const reg = /([\w]+)-(.+)/;
  const matches = customerId.match(reg);

  return (
    <>
      <AdminLayout title="Inheriters">
        <AdminCompanyInheriters companyId={matches[2]} />
      </AdminLayout>
    </>
  );
};

export default withAuthenticationRequired(InheritersPage);
